import { api } from './api';
import { callMainTenantAPIsOnly, searchGetCourseMeta } from './helpers';
import { getTenant } from '../helpers';

const filterUserCourses = (data) => {
  const seen = new Set();
  return data.filter((item) => {
    const duplicate = seen.has(item.course_id);
    seen.add(item.course_id);
    return !duplicate;
  });
};
export function getUserCoursesAPI(username: string, withAPIFullResponse=false): Promise<any> {
  return new Promise<any>((resolve, reject) => {
    const tenant = getTenant();

    // Function to fetch courses for a specific tenant
    const fetchCourses = (tenantKey: string) => {
      return new Promise<any>((_resolve, _reject) => {
        const requestData = {
          username: username,
          // platform_key: tenantKey,
          include_default_platform: 1,
        };

        api.ibldmcourses.getUserCourses(
          requestData,
          (response) => {
            if(withAPIFullResponse){
              _resolve(response)
            }
            if (response?.results && Array.isArray(response?.results)) {
              _resolve(response?.results);
            } else {
              _resolve([]);
            }
          },
          (error) => {
            console.error('getUserCourses: ', error);
            _reject(error);
          }
        );
      });
    };

    fetchCourses(tenant)
      .then((courses) => resolve(courses))
      .catch((error) => reject(error));
  });
}

export function getUserCoursesMetaData(course_id): any {
  return new Promise((resolve) => {
    api.ibledxcourses.getCourseMeta({ course_key: course_id }, function (data) {
      resolve(data);
    });
  });
}

export function getUserCoursesSearchData(course_id) {
  return new Promise((resolve) => {
    searchGetCourseMeta(course_id, (metaData) => {
      if (
        metaData &&
        !metaData.message &&
        metaData.results &&
        Array.isArray(metaData.results) &&
        metaData.results.length > 0
      ) {
        resolve(metaData.results[0]);
      } else {
        // TODO : will this not return an error when resolving ?
        resolve(null);
      }
    });
  });
}
